var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',[_c('avue-crud',{ref:"crud",attrs:{"option":_vm.option,"data":_vm.todoList},on:{"on-load":_vm.getTodoList},scopedSlots:_vm._u([{key:"over_day",fn:function({row}){return [_vm._v(" "+_vm._s(row.over_day)+"天 ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }